/* eslint-disable import/extensions */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { getObjectWithLanguage } from './HelperContent';
import languageData from '../locale/lan.json';
import en from '../locale/en.json';

import hi from '../locale/hi.json';

import sp from '../locale/sp.json';

import pt from '../locale/pt.json';

import it from '../locale/it.json';

import fr from '../locale/fr.json';

const lang = localStorage.getItem('user_language') || 'en';

const multipleLanguagesObject = {
	en,
	hi,
	sp,
	it,
	fr,
	pt
};

const localeData = multipleLanguagesObject[lang];

export const HamburgerContext = React.createContext({
	setHamBurgerShow    : (data) => {},
	hamBurgerShow       : false,
	setContactHamber    : (data) => {},
	contactHamBurger    : '',
	showSideNavIcons    : false,
	setShowSideNavIcons : (data) => {},
	maximizeScreen      : false,
	setMaximizeScreen   : (data) => {}
});

export const ChatContext = React.createContext({
	getRoomsList : (data, skipV) => {},
	value        : 0,
	setValue     : (data) => {},
	chatData     : { roomInfo: {}, msgCount: 0, messages: [] },
	setChatData  : (data) => {}
});

export const TaskContext = React.createContext({
	taskList      : [],
	setTaskList   : (data) => {},
	taskFilter    : { all: true, pending: true, completed: true, assinee: [ true, true ] },
	setTaskFilter : (data) => {}
});

export const CallContext = React.createContext({
	callStream          : null,
	isOnline            : true,
	setCallStream       : (data) => {},
	clearTracks         : (data) => {},
	updateCallDetails   : (message, time, data) => {},
	peerConnectionClose : (data) => {},
	handleAccept        : (data) => {},
	setupPeerConnection : (data) => {},
	handleCall          : (data) => {},
	callDbCallBack      : (data) => {},
	handleAudioOff      : (isMute) => {},
	updateCallCamera    : (isCam) => {},
	setUpGroupCallInfo  : (msg, callDetails) => {}
});
export const NewsFeedContext = React.createContext({
	menuItem    : '',
	setMenuItem : (data) => {}
});
export const LanguageContext = React.createContext(localeData);

export const ResourceContext = React.createContext({
	count    : 0,
	setCount : (data) => {}
});

export const NewDesignContext = React.createContext({
	setDisableBtn : (data) => {}
});

export const ContractTemplateContext = React.createContext({
	updateFormData       : (data) => {},
	formData             : {},
	canvas               : null,
	setCanvas            : (data) => {},
	setMainPagesElements : (data) => {},
	mainPagesElements    : [],
	mainCanvas           : {},
	setMainCanvas        : (data) => {},
	temDataRef           : {}
});

export const CollaborationContext = React.createContext({
	peerData               : {},
	setPeerData            : (data) => {},
	combinedId             : '',
	myData                 : {},
	groupData              : {},
	showLiveCall           : {},
	setShowLiveCall        : (data) => {},
	setGroupData           : (data) => {},
	userStatus             : {},
	setUserStatus          : (data) => {},
	setSelectedUsers       : (data) => {},
	selectedUsers          : [],
	selectedMessages       : null, // null - hide checkbox, [] - show checkboxes
	setSelectedMessages    : (data) => {},
	setReminder            : (data) => {},
	reminder               : {},
	setSliderContentIndex  : (data) => {},
	sliderContentIndex     : null,
	setSidebarContentIndex : (data) => {},
	sidebarContentIndex    : null,
	action                 : {},
	handleAction           : (type, key, value) => {}
});
